import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation } from 'lucide-react';
export function StrategicMap() {
  return <section id="map" className="py-12 bg-federal-blue text-white overflow-hidden" data-id="element-279">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-280">
        <div className="grid lg:grid-cols-5 gap-12 items-center" data-id="element-281">
          <div className="lg:col-span-2" data-id="element-282">
            <h2 className="text-muted-gold text-sm font-black tracking-[0.2em] uppercase mb-6" data-id="element-283">
              Geographical Strategic Hub
            </h2>
            <h3 className="text-4xl font-black mb-8 leading-tight" data-id="element-284">
              Local Presence, <br data-id="element-285" />
              National Impact.
            </h3>
            <p className="text-white/70 text-lg mb-10 leading-relaxed" data-id="element-286">
              Strategically positioned in the corridor between{' '}
              <span className="text-white font-bold" data-id="element-287">Charlotte, NC</span> and
              the <span className="text-white font-bold" data-id="element-288">Baltimore/MD</span>{' '}
              region. We are uniquely situated to support both agency
              headquarters and regional field offices.
            </p>

            <div className="space-y-6" data-id="element-289">
              <div className="flex items-start gap-4 p-4 bg-white/5 border border-white/10 rounded-sm" data-id="element-290">
                <MapPin className="w-6 h-6 text-muted-gold mt-1" data-id="element-291" />
                <div data-id="element-292">
                  <h4 className="font-bold text-lg" data-id="element-293">Mid-Atlantic Hub</h4>
                  <p className="text-sm text-white/60" data-id="element-294">
                    Baltimore, MD & Washington D.C. Metro
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 bg-white/5 border border-white/10 rounded-sm" data-id="element-295">
                <MapPin className="w-6 h-6 text-muted-gold mt-1" data-id="element-296" />
                <div data-id="element-297">
                  <h4 className="font-bold text-lg" data-id="element-298">Southeast Hub</h4>
                  <p className="text-sm text-white/60" data-id="element-299">
                    Charlotte & Raleigh, NC Research Triangle
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 relative" data-id="element-300">
            <div className="aspect-video bg-slate-900/50 rounded-lg border border-white/10 relative overflow-hidden group" data-id="element-301">
              {/* Abstract Map Visualization */}
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
              backgroundSize: '50px 50px'
            }} data-id="element-302" />

              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 450" data-id="element-303">
                {/* Connection Line */}
                <motion.path d="M250,350 Q400,225 550,100" fill="none" stroke="#C5A059" strokeWidth="3" strokeDasharray="10,10" initial={{
                pathLength: 0
              }} whileInView={{
                pathLength: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 2,
                ease: 'easeInOut'
              }} data-id="element-304" />

                {/* NC Point */}
                <g data-id="element-305">
                  <circle cx="250" cy="350" r="8" fill="#C5A059" data-id="element-306" />
                  <circle cx="250" cy="350" r="20" fill="#C5A059" fillOpacity="0.2" data-id="element-307">
                    <animate attributeName="r" from="8" to="30" dur="2s" repeatCount="indefinite" data-id="element-308" />
                    <animate attributeName="opacity" from="0.5" to="0" dur="2s" repeatCount="indefinite" data-id="element-309" />
                  </circle>
                  <text x="210" y="385" fill="white" fontSize="14" fontWeight="bold" className="uppercase tracking-widest" data-id="element-310">
                    Charlotte, NC
                  </text>
                </g>

                {/* MD Point */}
                <g data-id="element-311">
                  <circle cx="550" cy="100" r="8" fill="#C5A059" data-id="element-312" />
                  <circle cx="550" cy="100" r="20" fill="#C5A059" fillOpacity="0.2" data-id="element-313">
                    <animate attributeName="r" from="8" to="30" dur="2s" repeatCount="indefinite" data-id="element-314" />
                    <animate attributeName="opacity" from="0.5" to="0" dur="2s" repeatCount="indefinite" data-id="element-315" />
                  </circle>
                  <text x="565" y="95" fill="white" fontSize="14" fontWeight="bold" className="uppercase tracking-widest" data-id="element-316">
                    Baltimore, MD
                  </text>
                </g>

                {/* D.C. Point */}
                <g data-id="element-317">
                  <circle cx="510" cy="140" r="4" fill="white" data-id="element-318" />
                  <text x="450" y="155" fill="white" fontSize="10" fontWeight="bold" opacity="0.6" className="uppercase tracking-widest" data-id="element-319">
                    Washington D.C.
                  </text>
                </g>
              </svg>

              <div className="absolute top-6 right-6 bg-white/10 backdrop-blur-md p-4 rounded border border-white/10" data-id="element-320">
                <div className="flex items-center gap-3 mb-2" data-id="element-321">
                  <Navigation className="w-4 h-4 text-muted-gold" data-id="element-322" />
                  <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-323">
                    Strategic Corridor
                  </span>
                </div>
                <div className="text-xs font-medium opacity-70" data-id="element-324">
                  Rapid response within 4 hours to all Mid-Atlantic agencies.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}